/* eslint-disable react/no-unknown-property */
import type { FontsComponentProps } from './PreloadFonts';
import type { FC } from 'react';

import Head from 'next/head';

// Limited to codepoints confirmed present in each file's own cmap (verified against the live
// assets) — the previous range claimed U+01E6-01E7, U+0440, and several currency symbols that
// don't actually exist in these Helvetica Now subsets.
const UNICODE_RANGE =
  'U+0020-007E,U+00A1-017E,U+2013,U+2018-201A,U+201C-201E,U+2020-2022,U+2026,U+2032-2033,U+2039-203A,U+20AC,U+20B8-20BA,U+2122';

const fontface = (fontAssetPath: string) => `
@font-face {
  font-family: "Helvetica Now";
  src: url('${fontAssetPath}/HelveticaNowDisplayRegular_normal_normal_subset1.woff2') format('woff2');
  font-weight: 400;
  font-display: swap;
  font-style: normal;
  unicode-range: ${UNICODE_RANGE};
}

@font-face {
  font-family: "Helvetica Now";
  src: url('${fontAssetPath}/HelveticaNowDisplayBold_normal_normal_subset1.woff2') format('woff2');
  font-weight: 700;
  font-display: swap;
  font-style: normal;
  unicode-range: ${UNICODE_RANGE};
}

@font-face {
  font-family: "Helvetica Now Condensed";
  src: url('${fontAssetPath}/HelveticaNowDisplay_normal_condensed_700_subset1.woff2') format('woff2');
  font-weight: 700;
  font-display: swap;
  font-style: normal;
  unicode-range: ${UNICODE_RANGE};
}
`;

export const AAFFonts: FC<FontsComponentProps> = ({ fontAssetPath }) => (
  <Head>
    <link
      rel="preload"
      href={`${fontAssetPath}/HelveticaNowDisplayRegular_normal_normal_subset1.woff2`}
      as="font"
      type="font/woff2"
      fetchPriority="high"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={`${fontAssetPath}/HelveticaNowDisplayBold_normal_normal_subset1.woff2`}
      as="font"
      type="font/woff2"
      fetchPriority="high"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href={`${fontAssetPath}/HelveticaNowDisplay_normal_condensed_700_subset1.woff2`}
      as="font"
      type="font/woff2"
      fetchPriority="high"
      crossOrigin="anonymous"
    />
    {/* eslint-disable-next-line react/no-danger */}
    <style type="text/css" dangerouslySetInnerHTML={{ __html: fontface(fontAssetPath) }} />
  </Head>
);
